<template>
  <el-card class="bundle-card" shadow="hover">
    <div class="bundle-layout">
      <!-- Info Section -->
      <div class="bundle-info">
        <h3 class="bundle-title">{{ bundle.bundle_name }}</h3>
        <p class="bundle-description">{{ bundle.bundle_description || 'No description' }}</p>

        <!-- Cover Section -->
        <div class="cover-section">
          <div class="collections-preview">
            <template v-if="previewCollections.length > 0">
              <div
                v-for="(collection, index) in previewCollections"
                :key="`${bundle._id ? (bundle._id.$oid || bundle._id.$id) : bundle.id}-${collection._id ? (collection._id.$oid || collection._id.$id) || collection._id : collection.id || index}-${index}`"
                class="collection-preview-item"
                :style="{
                  left: `${index * 110}px` /* 100px width + 10px gap */
                }"
              >
                <el-image
                  :src="collection.cover_url"
                  :key="`img-${bundle._id ? (bundle._id.$oid || bundle._id.$id) : bundle.id}-${collection._id ? (collection._id.$oid || collection._id.$id) || collection._id : collection.id}-${collection.cover_url}`"
                  fit="cover"
                  class="collection-cover"
                >
                  <div slot="error" class="image-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div v-if="remainingCollections > 0" class="more-collections">
                +{{ remainingCollections }} more
              </div>
            </template>
            <div v-else class="empty-preview">
              <i class="el-icon-collection"></i>
              <span>No Collections</span>
            </div>
          </div>
        </div>

        <div class="bundle-meta">
          <span class="price">FREE</span>
          <div class="bundle-status" v-if="showStatus">
            <el-tag
              :type="bundle.bundle_status === 'PUBLISHED' ? 'success' : 'info'"
              size="small"
            >
              {{ bundle.bundle_status }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'BundleSimple',
  props: {
    bundle: {
      type: Object,
      required: true
    },
    showStatus: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    previewCollections() {
      // Use collection_array which contains full collection objects with cover_url
      // bundle_collections is just an array of IDs, not usable for display
      const collections = this.bundle.collection_array
      if (!collections) return []

      // Handle both array and object formats
      const collectionsArray = Array.isArray(collections)
        ? collections
        : Object.values(collections)

      return collectionsArray.slice(0, 3)
    },
    remainingCollections() {
      const collections = this.bundle.collection_array
      if (!collections) return 0

      const collectionsArray = Array.isArray(collections)
        ? collections
        : Object.values(collections)

      return Math.max(0, collectionsArray.length - 3)
    }
  }
}
</script>

<style scoped>
.original-price {
  text-decoration: line-through;
  color: #909399;
  margin-left: 8px;
  font-size: 0.9em;
}
.bundle-card {
  cursor: pointer;
  transition: transform 0.3s;
  width: 100%;
  max-width: 100%;
}

.bundle-card:hover {
  transform: translateY(-5px);
}

.bundle-card :deep(.el-card__body) {
  width: 100%;
  padding: 0;
}

.bundle-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.bundle-info {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cover-section {
  position: relative;
  height: 140px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.collections-preview {
  position: relative;
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
}

.collection-preview-item {
  position: absolute;
  width: 100px;
  height: 140px;
  transition: transform 0.3s;
}

.collection-cover {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.empty-preview {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.empty-preview i {
  font-size: 32px;
  margin-bottom: 8px;
}

.bundle-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.bundle-description {
  margin: 0;
  font-size: 14px;
  color: #606266;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bundle-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #909399;
  font-size: 14px;
}

.collection-count {
  display: flex;
  align-items: center;
  gap: 5px;
}

.price {
  font-weight: 600;
  color: #409EFF;
}

.bundle-status {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
  font-size: 24px;
}

.more-collections {
  position: absolute;
  left: 330px; /* Positioned after the last preview item */
  top: 50%;
  transform: translateY(-50%);
  color: #909399;
  font-size: 14px;
  white-space: nowrap;
}
</style> 